import { Mutex } from 'await-semaphore';
import { AuthServiceV3Impl } from './AuthServiceV3';
export class AuthServiceProviderV3Impl {
    constructor(authServiceOptions, sharedState, envConfigService, cookieService, logger) {
        this.authServiceOptions = authServiceOptions;
        this.sharedState = sharedState;
        this.envConfigService = envConfigService;
        this.cookieService = cookieService;
        this.logger = logger;
        this.registeredAuthServices = {};
        this.registeredAuthServices = {};
    }
    /**
     * Creates a new AuthService instance or returns an existing instance for an already registered fag.
     * @param fag FeatureAppGroup to register for
     */
    register(fag) {
        if (!this.authServiceOptions.fagScopeMappings.get(fag)) {
            throw new Error(`Unknown feature app group "${fag}". Please check authService configuration.`);
        }
        if (this.registeredAuthServices[fag]) {
            return this.registeredAuthServices[fag];
        }
        let sharedAuthServiceState = this.sharedState.authServiceState.get(fag);
        if (!sharedAuthServiceState) {
            sharedAuthServiceState = { mutex: new Mutex() };
            this.sharedState.authServiceState.set(fag, sharedAuthServiceState);
        }
        const service = new AuthServiceV3Impl(this.sharedState.eventEmitter, this.authServiceOptions, this.loginAll.bind(this), sharedAuthServiceState, this.envConfigService, this.cookieService, this.logger);
        this.registeredAuthServices[fag] = service;
        return service;
    }
    // TODO: login only fags which are not already authenticated? currently each call logs in all fags
    loginAll(_prompt, redirectUrl) {
        const { ssoUrl: loginUrl, defaultLoginRedirectUrl } = this.authServiceOptions;
        const url = new URL(loginUrl, window.location.origin);
        url.searchParams.set('targetUrl', redirectUrl || defaultLoginRedirectUrl);
        window.location.assign(url.toString());
    }
}
//# sourceMappingURL=AuthServiceProviderV3.js.map